import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';
import heroImage from '../images/hero-bride.jpg';
import kulDeviImage from '../images/kul-devi-piplaj-mata.jpg';
import { LiveRateTicker } from '../components/LiveRateTicker';

const HomePage = () => {
  return (
    <div className="page-container">
      <div className="homepage">
        {/* Live Rate Ticker */}
        <div className="ticker-section">
          <LiveRateTicker />
        </div>

        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <div className="trust-badge">
              <span className="trust-line"></span>
              <span className="trust-text">From the Legacy of Manoj Abhushan Bhandar</span>
            </div>
            <h1>Trusted Jewellery Shop in Rajasthan for Gold & Silver Jewellery</h1>
            <p className="jp-soni-credit">by <span className="jp-soni-name">Jayprakash Soni</span></p>

            <p>
              Experience the finest handcrafted jewellery that celebrates every emotion.
              Pure, Hallmark certified, and timeless.
            </p>

            <div className="hero-actions">
              <Link to="/jewellery" className="btn-hero-primary">View Collection</Link>
              <a href="https://wa.me/+919414817620" target="_blank" rel="noreferrer" className="btn-hero-secondary btn-whatsapp-hero">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" style={{ marginRight: '8px' }}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" /></svg>
                Chat on WhatsApp
              </a>
            </div>
          </div>
          <div className="hero-image-container">
            <img src={heroImage} alt="Indian Bride Emotional Jewellery" className="hero-image" />
          </div>
        </div>

        {/* Shop By Occasion */}
        <div className="occasion-section">
          <h2 className="section-heading">Shop By Occasion</h2>
          <p className="section-subheading">Jewellery for every moment of your life</p>

          <div className="occasion-grid">
            <Link to="/jewellery?tag=wedding" className="occasion-card wedding">
              <div className="occasion-content">
                <h3>Wedding Collection</h3>
                <p>For your special day</p>
              </div>
            </Link>
            <Link to="/jewellery?tag=daily" className="occasion-card daily">
              <div className="occasion-content">
                <h3>Daily Wear</h3>
                <p>Elegant & Lightweight</p>
              </div>
            </Link>
            <Link to="/jewellery?tag=festival" className="occasion-card festival">
              <div className="occasion-content">
                <h3>Festival & Party</h3>
                <p>Celebrate in style</p>
              </div>
            </Link>
            <Link to="/live-gold-rate" className="occasion-card investment">
              <div className="occasion-content">
                <h3>Gold Investment</h3>
                <p>Secure your future</p>
              </div>
            </Link>
          </div>
        </div>

        {/* Featured SEO Collections */}
        <div className="occasion-section" style={{ background: '#fff' }}>
          <h2 className="section-heading">Explore Our Special Collections</h2>
          <p className="section-subheading">Handpicked for You</p>

          <div className="occasion-grid">
            <Link to="/gold-jewellery-jodhpur" className="occasion-card" style={{ background: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(https://images.unsplash.com/photo-1611591437281-460bfbe1220a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80)', backgroundSize: 'cover' }}>
              <div className="occasion-content">
                <h3>Gold Jewellery in Jodhpur</h3>
                <p>BIS Hallmark Certified</p>
              </div>
            </Link>
            <Link to="/wedding-jewellery-rajasthan" className="occasion-card" style={{ background: 'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(https://images.unsplash.com/photo-1583934555026-63b5b449ac20?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80)', backgroundSize: 'cover' }}>
              <div className="occasion-content">
                <h3>Wedding Jewellery</h3>
                <p>Bridal Sets & Bangles</p>
              </div>
            </Link>
            <Link to="/gold-rate-jodhpur" className="occasion-card" style={{ background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(https://images.unsplash.com/photo-1610375460969-d958614b479c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80)', backgroundSize: 'cover' }}>
              <div className="occasion-content">
                <h3>Today's Gold Rate</h3>
                <p>Live Market Prices</p>
              </div>
            </Link>
          </div>
        </div>

        {/* Trust & Legacy Section */}
        <div className="trust-section">
          <div className="trust-grid">
            <div className="trust-item">
              <div className="trust-icon">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M8 21h8m-4-9v9m0-9a5 5 0 0 1-5-5V3h10v4a5 5 0 0 1-5 5Z" />
                </svg>
              </div>
              <h3>100% Hallmark</h3>
              <p>Certified purity you can trust blindly.</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 3h12l4 6-10 13L2 9Z" />
                  <path d="M11 3 8 9l4 13 4-13-3-6" />
                  <path d="M2 9h20" />
                </svg>
              </div>
              <h3>Handcrafted</h3>
              <p>Made by India's finest Karigars.</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m11 17 2 2a6 6 0 0 0 8.5-8.5l-2-2L18.06 10a1.5 1.5 0 0 0-2.12 0l-.88.88a1.5 1.5 0 0 1-2.12 0l-.88-.88a1.5 1.5 0 0 0-2.12 0L9.94 10l-1.44-1.44a1.5 1.5 0 0 0-2.12 0L5.5 9.44a1.5 1.5 0 0 0 0 2.12l8.88 8.88" />
                  <path d="M18.5 5.5a6 6 0 0 1 8.5 8.5l-2 2" />
                </svg>
              </div>
              <h3>Lifetime Exchange</h3>
              <p>Best value for your investment.</p>
            </div>
            <a href="https://www.google.com/maps/search/?api=1&query=Manoj+Abhushan+Bhandar+Anandpur+Kalu" target="_blank" rel="noreferrer" className="trust-item store-link">
              <div className="trust-icon">
                <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <h3>Visit Store</h3>
              <p>Anandpur Kalu</p>
            </a>
          </div>
        </div>
      </div>
      {/* Local SEO Section */}
      <div className="location-section" style={{ padding: '40px 20px 20px', background: '#f9f9f9', textAlign: 'center' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div className="kul-devi-container">
            <img src={kulDeviImage} alt="Shree Piplaj Mata Ji - Kuldevi Khajwaniyan" className="kul-devi-image" />
          </div>
          <h2 style={{ fontSize: '2rem', marginBottom: '20px', color: '#1a1a1a' }}>Jewellery Shop in Jodhpur, Rajasthan</h2>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#555' }}>
            MAB Jewels is a trusted <strong>jewellery shop in Jodhpur</strong> offering pure gold jewellery, wedding jewellery, and custom designs for families across Rajasthan.
            Whether you are looking for the <strong>best jeweller near me</strong> or specific <strong>gold jewellery in Rajasthan</strong>, our legacy of craftsmanship ensures you get only the finest BIS Hallmarked pieces.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 